import { formatCurrency } from "@/helpers/currency";
import AmountTypes from "@/constants/authorizationAmountTypes";
import AuthorizationChargeTypes, {
  AuthorizationChargeTypeLabels
} from "@/constants/authorizationChargeTypes";

export default authorization => {
  if (authorization.charges == AuthorizationChargeTypes.OTHER) {
    return authorization.charges_other;
  } else if (authorization.charges == AuthorizationChargeTypes.AMOUNT_OF) {
    let prefix = "";
    if (authorization.amount_type == AmountTypes.UP_TO_AMOUNT) {
      prefix = "Up to ";
    }
    return `${prefix}${formatCurrency(
      authorization.amount,
      authorization.currency
    )}`;
  } else {
    return AuthorizationChargeTypeLabels[authorization.charges];
  }
};
